'use client';
import Image from 'next/image';
import Link from 'next/link';
import { usePathname } from 'next/navigation';
import React from 'react';

export default function NormalHeader() {
  const pathname = usePathname();
  const noLogoRoutes = ['/personal/onfido', '/partial-login', '/partial-signup']; // List of routes where only the logo should be shown
  const normalizedPathname = pathname.startsWith('/') ? pathname : `/${pathname}`;

  const noHeaderRoutes = ['/', '/partial-option-landing', '/login-landing']; // List of routes where only the logo should be shown
  const isNoLogoPage = noLogoRoutes.some((route) => normalizedPathname.startsWith(route));

  // Normalize pathname, ensuring it starts with a slash for comparison
  const isBlack = noHeaderRoutes.includes(pathname);

  return (
    <>
      {!isBlack && !isNoLogoPage && (
        <div className="w-full z-10 h-[70px]  hidden sm:flex md:flex bg-white lg:flex">
          <Link className="cursor-pointer" href="/">
            <Image src="/blueLogo.svg" height={100} className="w-[200px] h-[80px] p-4" width={100} alt="Logo" />
          </Link>
        </div>
      )}
    </>
  );
}
